//*
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
//
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
//
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs, { Dayjs } from "dayjs";
// after
import { Link as RLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
//import styles from "./User.module.css";
import { SerializedError } from "../../util/types";
import { Filter, FilterForm } from "./filterSlice";
import EditBar from "./EditBar";
import { useFileViewQuery, useFileEditMutation } from "../../api/file";
import { Contact } from "../contact/contactSlice";
import ContactComplete from "../contact/AutoComplete";

/*
expor   t default function FileEditLayout() {
    let { id } = useParams();
    const idStr = id ? id : "";
    //const file = useAppSelector(selectTicket(idStr));
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useFileViewQuery(idStr, { refetchOnMountOrArgChange: true });
    let content: React.ReactNode;

    if (isLoading) {
        content = <FileViewerLoading />;
    } else if (isFetching) {
        content = <FileViewerFetching />;
    } else if (isSuccess) {
        content = <FileEditDisplay file={toEditRequest(data.file)} />;
    } else if (isError) {
        content = <FileViewerError error={error} />;
    }
    return <Box>{content}</Box>;
}

export default function FileEditDisplay() {
    //console.log("in file edit display", file);
    const navigate = useNavigate();
    let { id } = useParams();
    const idv = id ? id : null;
    const idStr = id ? id : "";
    let [fmer, setFMER] = React.useState<FileMetadataEditRequest | null>(null);
    console.log("202511212228", fmer);
    const [updateFile, { isLoading: isUpdating }] = useFileEditMutation();
    const onSave = () => {
        if (fmer) {
            updateFile(fmer)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.file) {
                        navigate("/file/view/" + fullfilled.file.metadata.id);
                    }
                });
        }
        console.log("2024101608254", fmer);
    };
    const {
        //data: TicketItemsResponse,
        data,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
    } = useFileViewQuery(idStr, { refetchOnMountOrArgChange: true });
    let content: React.ReactNode;

    if (isLoading) {
        content = <FileViewerLoading />;
    } else if (isFetching) {
        content = <FileViewerFetching />;
    } else if (isSuccess) {
        content = (
            <FileEditForm
                fmer={toEditRequest(data)}
                onSave={onSave}
                onFMERChange={(fmer: FileMetadataEditRequest) => {
                    console.log("putting fmer", fmer);
                    setFMER(fmer);
                }}
            />
        );
    } else if (isError) {
        content = <FileViewerError error={error} />;
    }
    return <>{content} </>;
}
// */
interface ChildProps {
    ff: FilterForm;
    onFFChange: (ff: FilterForm) => void;
    onSave: () => void;
}
export function EditForm({ ff, onFFChange, onSave }: ChildProps) {
    console.log("202511212216 - FileEditForm", ff);
    const theme = useTheme();
    const sx = {
        backgroundColor: "#eeeeee",
        display: "flex",
        height: theme.mixins.toolbar.minHeight,
        width: "100%",
        paddingLeft: 3,
        paddingRight: 8,
        alignItems: "center",
        zIndex: theme.zIndex.appBar,
    };

    const [nameV, setName] = useState<string>(ff.name || "");
    const onNameChange = (t: string) => {
        //ticketV.title = t;
        setName(t);
        let f = getForm();
        f.name = t;
        onFFChange(f);
    };
    const [searchText, setSearchText] = useState<string>(ff.search_text || "");
    const onSearchTextChange = (t: string) => {
        //ticketV.title = t;
        setSearchText(t);
        let f = getForm();
        f.search_text = t;
        onFFChange(f);
    };
    const initialPlannedStartMin = ff.planned_start_min;
    const [plannedStartMin, setPlannedStartMin] = useState<Dayjs | null>(
        initialPlannedStartMin ? dayjs(initialPlannedStartMin) : null,
    );
    const onSetPlannedStartMin = (d: Dayjs | null) => {
        //ticketV.start = d ? d.toDate().toISOString() : null;
        let plannedStartMin = setPlannedStartMin(d);
        let f = getForm();
        f.planned_start_min = d
            ? d.toDate().toISOString()
            : new Date().toISOString();
        onFFChange(f);
    };
    const onDeletePlannedStartMin = () => {
        //ticket.start = null;
        let plannedStartMin = setPlannedStartMin(null);
        let f = getForm();
        f.planned_start_min = null;
        onFFChange(f);
    };
    const initialPlannedStartMax = ff.planned_start_max;
    const [plannedStartMax, setPlannedStartMax] = useState<Dayjs | null>(
        initialPlannedStartMax ? dayjs(initialPlannedStartMax) : null,
    );
    const onSetPlannedStartMax = (d: Dayjs | null) => {
        //ticketV.start = d ? d.toDate().toISOString() : null;
        let plannedStartMax = setPlannedStartMax(d);
        let f = getForm();
        f.planned_start_max = d
            ? d.toDate().toISOString()
            : new Date().toISOString();
        onFFChange(f);
    };
    const onDeletePlannedStartMax = () => {
        //ticket.start = null;
        let plannedStartMax = setPlannedStartMax(null);
        let f = getForm();
        f.planned_start_max = null;
        onFFChange(f);
    };
    const initialLevel_1 = ff.level_1;
    const [level_1, setLevel1] = useState<boolean>(initialLevel_1);
    const onSetLevel1 = () => {
        let l1 = !level_1;
        setLevel1(l1);
        let f = getForm();
        f.level_1 = l1;
        onFFChange(f);
    };
    const initialLevel_2 = ff.level_2;
    const [level_2, setLevel2] = useState<boolean>(initialLevel_2);
    const onSetLevel2 = () => {
        let l2 = !level_2;
        setLevel2(l2);
        let f = getForm();
        f.level_2 = l2;
        onFFChange(f);
    };
    const initialLevel_3 = ff.level_3;
    const [level_3, setLevel3] = useState<boolean>(initialLevel_3);
    const onSetLevel3 = () => {
        let l3 = !level_3;
        setLevel3(l3);
        let f = getForm();
        f.level_3 = l3;
        onFFChange(f);
    };
    const initialLevel_4 = ff.level_4;
    const [level_4, setLevel4] = useState<boolean>(initialLevel_4);
    const onSetLevel4 = () => {
        let l4 = !level_4;
        setLevel4(l4);
        let f = getForm();
        f.level_4 = l4;
        onFFChange(f);
    };
    const initialLevel_5 = ff.level_5;
    const [level_5, setLevel5] = useState<boolean>(initialLevel_5);
    const onSetLevel5 = () => {
        let l5 = !level_5;
        setLevel5(l5);
        let f = getForm();
        f.level_5 = l5;
        onFFChange(f);
    };
    const initialLevel_6 = ff.level_6;
    const [level_6, setLevel6] = useState<boolean>(initialLevel_6);
    const onSetLevel6 = () => {
        let l6 = !level_6;
        setLevel6(l6);
        let f = getForm();
        f.level_6 = l6;
        onFFChange(f);
    };
    const initialLevel = [
        ff.level_1,
        ff.level_2,
        ff.level_3,
        ff.level_4,
        ff.level_5,
        ff.level_6,
    ];
    const [levels, setLevels] = useState<boolean[]>(initialLevel);
    const onSetLevel = (i: number) => {
        levels[i] = !levels[i];
        setLevels(levels);
        console.log("202604181129", levels);
        let f = getForm();
        f.level_1 = levels[0];
        f.level_2 = levels[1];
        f.level_3 = levels[2];
        f.level_4 = levels[3];
        f.level_5 = levels[4];
        f.level_6 = levels[5];
        onFFChange(f);
    };
    const initialTags = ff.tags_or.join(",");
    const [tags, setTags] = useState<string>(initialTags);
    const onSetTag = (t: string) => {
        let tagsV: string[] = t
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s.length > 0);
        setTags(t);
        let f = getForm();
        f.tags_or = tagsV;
        onFFChange(f);
    };
    const onSetPro = () => {
        setTags("pro");
        let f = getForm();
        f.tags_or = ["pro"];
        onFFChange(f);
    };
    const onSetPriv = () => {
        setTags("priv,protos,fin,fdoe");
        let f = getForm();
        f.tags_or = ["priv", "protos", "fin", "fdoe"];
        onFFChange(f);
    };
    // */
    /*
    // contacts
    let initContacts: /* Contact[] * / { [key: string]: Contact } =
        fmer.contacts; //fmer ? fmer.contacts : {};
    console.log("this is initContacts: ", initContacts);
    let [contactsValue, setContacts] = React.useState<{
        [key: string]: Contact;
    }>(initContacts);
    const onContactsChange = (contacts: { [key: string]: Contact }) => {
        console.log("setting contacts to: ", contacts);
        let contactsValue = setContacts(contacts);
        //ticketV.content = content;
        let f = getForm();
        f.contacts = contacts;
        console.log("setting fmer.contacts to: ", f, contacts);
        onFFChange(f);
    };
    const handleRemoveContact = (toRemove: Contact) => {
        console.log("YIHHAAAAAA", contactsValue);
        const key = toRemove.metadata.id;
        if (key) {
            const { [key]: _, ...rest } = contactsValue;
            const newObj = rest;
            console.log(newObj);
            setContacts(newObj);
        }
    };

    const handleAddContact = (newContact: Contact) => {
        setContacts((prev) => {
            // avoid duplicates by id if you want
            /*
            if (prev.some((c) => c.metadata.id === newContact.metadata.id)) {
                return prev;
            }
            return [...prev, newContact];
            // * /
            if (newContact.metadata.id) {
                prev[newContact.metadata.id] = newContact;
            }
            return prev;
        });
    };
    // */
    //const onSave = () => { };
    const getForm = (): FilterForm => {
        return {
            id: ff.id,
            name: ff.name,
            search_text: searchText,
            in_content: false,
            kprivate: true,
            planned_start_min: ff.planned_start_min,
            planned_start_max: ff.planned_start_max,
            planned_end_min: ff.planned_end_min,
            planned_end_max: ff.planned_end_max,
            end_is_null: true,
            contexts_or: [],
            tags_or: ff.tags_or,
            labels_and: [],
            labels_or: [],
            parent_id: ff.parent_id,
            page_id: ff.page_id,
            contact_id: ff.contact_id,
            level_1: level_1, // area
            level_2: level_2, // space
            level_3: level_3, // project
            level_4: level_4, // epic
            level_5: level_5, // deliverable
            level_6: level_6, // task
            in_tickets: true,
            in_pages: false,
            in_files: false,
        };
    };
    return (
        <>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label="Name"
                        fullWidth
                        value={nameV}
                        onChange={(e) => {
                            onNameChange(e.target.value);
                        }}
                        size="small"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <DateTimePicker
                        label="planned start min"
                        value={plannedStartMin}
                        slotProps={{ textField: { size: "small" } }}
                        onChange={(newValue) => onSetPlannedStartMin(newValue)}
                        ampm={false}
                        format={"YYYY/MM/DD HH:mm"}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        label="Search Text"
                        fullWidth
                        value={searchText}
                        onChange={(e) => {
                            onSearchTextChange(e.target.value);
                        }}
                        size="small"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <DateTimePicker
                        label="Planned Start Max"
                        value={plannedStartMax}
                        slotProps={{ textField: { size: "small" } }}
                        onChange={(newValue) => onSetPlannedStartMax(newValue)}
                        ampm={false}
                        format={"YYYY/MM/DD HH:mm"}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Link component={RLink} to={"/filter/view/2"}>
                        <Button variant="text" onClick={onSetPro}>
                            Pro
                        </Button>{" "}
                    </Link>
                    -
                    <Link component={RLink} to={"/filter/view/1"}>
                        <Button variant="text" onClick={onSetPriv}>
                            Priv*
                        </Button>
                    </Link>
                    <TextField
                        label="tag (or)"
                        size="small"
                        fullWidth
                        value={tags}
                        onChange={(e) => {
                            onSetTag(e.target.value);
                        }}
                    />
                    <br />
                    <br />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={level_1}
                                    onChange={onSetLevel1}
                                />
                            }
                            label="a"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={level_2}
                                    onChange={onSetLevel2}
                                />
                            }
                            label="g"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={level_3}
                                    onChange={onSetLevel3}
                                />
                            }
                            label="p"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={level_4}
                                    onChange={onSetLevel4}
                                />
                            }
                            label="e"
                        />
                        <FormControlLabel
                            required
                            control={
                                <Checkbox
                                    checked={level_5}
                                    onChange={onSetLevel5}
                                />
                            }
                            label="d"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={level_6}
                                    onChange={onSetLevel6}
                                />
                            }
                            label="t"
                        />
                    </FormGroup>
                </Grid>
                <Grid size={12}>
                    {/*
                    <ContactComplete
                        contacts={fmer.contacts}
                        onChange={onContactsChange}
                        onRemove={handleRemoveContact}
                        onAdd={handleAddContact}
                    />
                    */}
                </Grid>
                <Grid size={12}>
                    {/*
                    <TextField
                        id="filter-edit-tag"
                        label="Tag"
                        variant="standard"
                        defaultValue={initTag}
                        placeholder="Placeholder"
                        inputProps={{ style: { fontFamily: "courier new" } }}
                        multiline
                        fullWidth
                        onChange={(e) => {
                            onTagChange(e.target.value);
                        }}
                        sx={{ fontFamily: "courrier" }}
                    />
                     */}
                </Grid>
            </Grid>
        </>
    );
}

export function FileViewerLoading() {
    return <Box>Loading</Box>;
}

export function FileViewerFetching() {
    return <Box>Fetching</Box>;
}

export function FileViewerError({
    error,
}: {
    error: FetchBaseQueryError | SerializedError | undefined;
}) {
    return <Box>Error</Box>;
}
